import type { GQAccountItem } from "@/admin/accounts/AccountsTable.tsx";
import { DeleteAccountBlock } from "@/admin/accounts/DeleteAccountBlock.tsx";
import { RelatedItems } from "@/admin/RelatedItems.tsx";
import { WModalButton } from "@/components/button/WToolButton.tsx";
import { Toolbar } from "@/components/Toolbar.tsx";

export function AccountsToolbar({ item }: { item: GQAccountItem }) {
    return (
        <Toolbar>
            <RelatedItems id={item.id} from="fromAccount" />
            <DeleteAccountBlock
                item={item}
                button={<WModalButton isDisabled={!!item.is_deleted} label="Delete" size="md" icon="jp-trash-icon" />}
            />
        </Toolbar>
    );
}
